import { render } from "./DevPanel.vue?vue&type=template&id=c6f08e9c"
import script from "./DevPanel.vue?vue&type=script&lang=js"
export * from "./DevPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__